import { ExternalLink, Link2, Plus, Trash2 } from "lucide-react";
import { isSafeDocumentUrl, MAX_DOCUMENT_LINKS } from "../../../helpers/server/vendorDocumentLinks";

const INPUT_CLASS = "border-input w-full min-w-0 rounded-md border bg-transparent px-3 py-1 h-8 text-[13px]";

const VendorDocumentLinksSection = ({ value = [], onChange, access = "edit", error }) => {
    const canEdit = access === "edit";
    const updateLink = (index, field, nextValue) => {
        onChange(value.map((link, i) => i === index ? { ...link, [field]: nextValue } : link));
    };

    return (
        <div className="space-y-3">
            <p className="text-[12px] text-muted-foreground">
                Link Google Docs, Drive folders, agreements, or other documents. Sharing permissions stay with the original document.
            </p>
            {!value.length && <p className="text-[12px] text-muted-foreground italic">No document links yet.</p>}
            {value.map((link, index) => (
                <div key={index} className="min-w-0 space-y-2 rounded-md bg-gray-100 p-2.5">
                    <div className="flex min-w-0 items-center gap-2">
                        <Link2 className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
                        {isSafeDocumentUrl(link.url) ? (
                            <a
                                href={link.url.trim()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex min-w-0 flex-1 items-center gap-1 text-[12px] hover:underline"
                            >
                                <span className="truncate">{link.name.trim() || "Open document"}</span>
                                <ExternalLink className="h-3 w-3 shrink-0" />
                            </a>
                        ) : <span className="flex-1 text-[12px]">New document link</span>}
                        {canEdit && (
                            <button
                                type="button"
                                aria-label={`Remove document link ${index + 1}`}
                                onClick={() => onChange(value.filter((_, i) => i !== index))}
                                className="rounded p-2 text-muted-foreground hover:text-destructive"
                            >
                                <Trash2 className="h-3.5 w-3.5" />
                            </button>
                        )}
                    </div>
                    {canEdit && (
                        <div className="grid min-w-0 gap-2 sm:grid-cols-2">
                            <label className="min-w-0 space-y-1 text-[12px]">
                                <span>Name</span>
                                <input
                                    className={INPUT_CLASS}
                                    value={link.name}
                                    maxLength={200}
                                    placeholder="e.g. Supplier agreement"
                                    onChange={(event) => updateLink(index, "name", event.target.value)}
                                />
                            </label>
                            <label className="min-w-0 space-y-1 text-[12px]">
                                <span>URL</span>
                                <input
                                    className={INPUT_CLASS}
                                    type="url"
                                    value={link.url}
                                    maxLength={4096}
                                    placeholder="https://docs.google.com/..."
                                    onChange={(event) => updateLink(index, "url", event.target.value)}
                                />
                            </label>
                        </div>
                    )}
                </div>
            ))}
            {error && <p role="alert" className="text-[12px] text-red-500">{error}</p>}
            {canEdit && (
                <div className="space-y-1">
                    <button
                        type="button"
                        onClick={() => onChange([...value, { name: "", url: "" }])}
                        disabled={value.length >= MAX_DOCUMENT_LINKS}
                        className="inline-flex items-center gap-1 rounded-md border border-border px-3 py-2 text-[12px] hover:bg-gray-50 disabled:opacity-50"
                    >
                        <Plus className="h-3.5 w-3.5" /> Add link
                    </button>
                    <p className="text-[11px] text-muted-foreground">Links are saved with the supplier.</p>
                </div>
            )}
        </div>
    );
};

export default VendorDocumentLinksSection;
